export const BASE_URL = 'http://freeattendance.nutraglobe.com/backend/';
// export const BASE_URL = "http://localhost/fap/index.php/";
// export const BASE_URL = "http://192.168.0.166:8080/ziman_backend/EasyDevReact/";
